import React, { useEffect } from "react";
import "./ComingSoonModal.css";

const DownloadAppModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) {
      return undefined;
    }

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div className="coming-soon-overlay" onClick={onClose}>
      <div
        className="coming-soon-modal download-app-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="download-app-title"
        onClick={(event) => event.stopPropagation()}
      >
        <p className="download-kicker">Bookings in the app</p>
        <h2 id="download-app-title">Coming soon</h2>
        <p>
          Hospital visits, walks, companionship and shopping are booked in the EldyCare app — not on this website.
        </p>

        <div className="download-store-row">
          <div className="download-store-badge" aria-label="Download on the App Store, coming soon">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M16.7 12.7c0-2.3 1.9-3.4 2-3.5-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.2-2.8.9-3.5.9s-1.8-1-3-1c-1.5 0-3 .9-3.8 2.3-1.6 2.8-.4 7 1.2 9.3.8 1.1 1.7 2.3 3 2.3 1.2 0 1.6-.7 3.1-.7s1.8.7 3.1.7 2.1-1.1 2.8-2.2c.9-1.2 1.2-2.4 1.2-2.5-.1 0-2.3-.9-2.3-3.8zM14.8 6.4c.7-.8 1.1-1.9 1-3-.9 0-2.1.6-2.8 1.4-.6.7-1.2 1.9-1 3 1 .1 2.1-.5 2.8-1.4z"
              />
            </svg>
            <span>
              <small>Download on the</small>
              <strong>App Store</strong>
            </span>
          </div>

          <div className="download-store-badge" aria-label="Get it on Google Play, coming soon">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path fill="#EA4335" d="M3.5 2.3 14 12 3.5 21.7V2.3z" />
              <path fill="#FBBC04" d="M3.5 21.7 14 12l3.3 3.1-11.4 6.5c-.8.5-1.8.4-2.4.1z" />
              <path fill="#4285F4" d="M20.6 10.3 17.3 8.4 14 12l3.3 3.1 3.3-1.9c.9-.5.9-2.4 0-2.9z" />
              <path fill="#34A853" d="M3.5 2.3c.6-.3 1.6-.4 2.4.1L17.3 8.4 14 12 3.5 2.3z" />
            </svg>
            <span>
              <small>GET IT ON</small>
              <strong>Google Play</strong>
            </span>
          </div>
        </div>

        <p className="coming-soon-stores">Coming soon on iOS and Android</p>

        <button className="coming-soon-later" type="button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default DownloadAppModal;
